import { render, staticRenderFns } from "./ProductSalesTable.vue?vue&type=template&id=f8b0b7c2&"
import script from "./ProductSalesTable.vue?vue&type=script&lang=js&"
export * from "./ProductSalesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports